'use strict';

import type { IndFlowAssignment } from '../../Entities/Ind/IndFlowAssignment';
import { EntityCollection } from '../EntityCollection';

export class IndFlowAssignmentCollection extends EntityCollection<IndFlowAssignment> {}
